import React, {Component} from 'react';
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {flash, getSharingDetailsPopup} from '../../../../../../../../../actions/sharingDetailsActions';
import {msgBar} from '../../../../../../../../../actions/msgBarActions';
import Button from "../../../../../../../../components/button";

class DeleteLabelButton extends Component {

    constructor(props){
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){
        e.preventDefault();

	    if(!e.currentTarget.dataset.disabled) {
		    this.props.getSharingDetailsPopup([true, "label_delete_confirm", {labelId: this.props.labelId, labelName: this.props.labelName}]);
	    } else {
            e.currentTarget.style.cursor = 'not-allowed';
            setTimeout(()=>{

            if(this.props.selectedContactsGroup.permission === 'WRITE_ONLY'){
	            this.props.flash({type: 'danger', message: this.props.t("textErrorPermission1")})
                }else{
	            this.props.flash({type: 'danger', message: this.props.t("msgBarErrorText5")})
            }},10)}
}


    render() {
        return (
            <Button className="btn-link" onClick={this.handleClick} data-disabled={this.props.disabled} aria-disabled={this.props.disabled} title={this.props.title}>
                <div className="more-option-item__picto">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            fill="currentColor"
                            d="M 5.333 24 C 4.6 24 3.971 23.739 3.449 23.217 C 2.928 22.695 2.666 22.067 2.666 21.334 L 2.666 4 L 1.333 4 L 1.333 1.333 L 8 1.333 L 8 0 L 16 0 L 16 1.333 L 22.667 1.333 L 22.667 4 L 21.333 4 L 21.333 21.334 C 21.333 22.067 21.072 22.695 20.551 23.217 C 20.027 23.739 19.4 24 18.667 24 L 5.333 24 Z M 18.667 4 L 5.333 4 L 5.333 21.334 L 18.667 21.334 L 18.667 4 Z M 8 18.667 L 10.667 18.667 L 10.667 6.666 L 8 6.666 L 8 18.667 Z M 13.334 18.667 L 16 18.667 L 16 6.666 L 13.334 6.666 L 13.334 18.667 Z M 5.333 4 L 5.333 21.334 L 5.333 4 Z"
                        />
                    </svg>
                </div>
                <div className="more-option-item__text">
                    <span>{this.props.title}</span>
                </div>
            </Button>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup: (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
	    flash: (array) => {
		    dispatch(flash(array))
	    },
        msgBar: (array) => {
            dispatch(msgBar(array))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeleteLabelButton));
